module.exports = __webpack_public_path__ + "img/P9220157.22f54346.jpg";